import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=2691a552"
import script from "./Redirect.vue?vue&type=script&lang=ts"
export * from "./Redirect.vue?vue&type=script&lang=ts"
import style0 from "./Redirect.vue?vue&type=style&index=0&id=2691a552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports